<template>
  <div></div>
</template>

<script>
import {mapGetters} from "vuex";
import CatalogUtils from "@/components/catalog/CatalogUtils.vue";

export default {
  name: "ComboUtils",
  components: {},
  props: {},
  methods: {
    openCombo: function (catalogElement) {
      const component = this;
      component.$store.commit('catalog/setSelectedProductLargeCard', catalogElement);
      const combo = catalogElement.element;
      component.initCombo(combo);
      component.setMeta(combo);
      component.addAnchor(combo);
    },
    initCombo: function (combo){
      const component = this;
      component.finishComboSet();
      component.$store.commit('combo/setComboItems', component.collectDefaultComboItems(combo));
    },
    collectDefaultComboItems: function (combo){
      const component = this;
      const defaultComboItems = [];
      combo.raw.groups.map(group => {
        const product = group.products[0];
        const productTitle =  component.comboItemProductTitle(component.productWithOffers(product), product);
        defaultComboItems.push({'groupId': group.id, 'productId': product.code, 'productTitle': productTitle});
      });
      return defaultComboItems;
    },
    changeCombo: function (combo){
      const component = this;
      const comboObjects = component.combos.filter(c => { return c.source_action_id === combo.action_id; });
      if(comboObjects.length){
        combo = Object.assign( {'code': combo.code, 'items': combo.items}, comboObjects[0]);
        component.$store.commit('combo/setComboItems', combo.items);
        component.$store.commit('combo/setCombo', combo);
        component.$store.commit('catalog/setSelectedProductLargeCard', {'element': combo});
      }
    },
    buildComboBasketItem: function (combo, comboItems, index){
      const comboCode = (combo !== undefined && combo.code === undefined) ? [combo.source_action_id, index].join("_") : combo.code;
      return {
        entity: 'combo',
        image: combo.picture,
        code: comboCode,
        action_id: combo.source_action_id,
        title: combo.title,
        price: combo.price,
        quantity: 1,
        items: comboItems
      };
    },
    isActiveCombo: function (items, groupId, productCode){
      if(items === undefined){
        return false;
      }
      return items.filter( i => { return i.groupId === groupId && i.productId === productCode}).length;
    },
    cancelChangeCombo: function (){
      const component = this;
      component.$store.commit('combo/setComboItemProducts', []);
      component.$store.commit('combo/setComboItemGroupId', null);
    },
    filterActiveProduct: function (p){
      const component = this;
      if(!component.isActiveCombo(component.comboItems, component.groupId, p.code)){
        return component.getActiveOffer(p).length > 0;
      }
      return true;
    },
    getActiveOffer: function (product){
      const component = this;
      if (component.productWithOffers(product)) {
        return product.offers.filter(o => component.isActiveCombo(component.comboItems, component.groupId, o.code));
      }
      return [];
    },
    productWithOffers: function (product){
      return product.offers !== undefined && product.offers.length > 1;
    },
    comboItemProductTitle: function (isOffer, product){
      return isOffer ? product.OFFER_NAME : product.NAME
    },
    finishComboSet(){
      this.$store.commit('combo/setCombo', null);
      this.$store.commit('combo/setComboItems', []);
      this.$store.commit('combo/setComboItemProducts', []);
      this.$store.commit('combo/setComboItemGroupId', null);
    }
  },
  computed: {
    ...mapGetters('catalog', {
      combos: 'getCombos'
    }),
    ...mapGetters('app', {
      phrases: 'getPhrases',
    }),
  },
  mixins:[CatalogUtils]
}
</script>

<style scoped>

</style>